"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _excluded = ["unique"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var propTypes = {
  unique: _propTypes.string
};

var CaretLeft = function CaretLeft(_ref) {
  var _ref$unique = _ref.unique,
      unique = _ref$unique === void 0 ? "" : _ref$unique,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("defs", {
    fill: "inherit"
  }), /*#__PURE__*/_react["default"].createElement("g", {
    fill: "inherit",
    fillRule: "evenodd",
    id: "glyphs/nav/caret_left-caret-left" + unique,
    stroke: "none",
    strokeWidth: 1
  }, /*#__PURE__*/_react["default"].createElement("g", {
    fill: "inherit",
    id: "colors/core/gunmetal-caret-left" + unique
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M16.7298146,20.1766484 L16.0654196,20.8410434 C15.8701575,21.0363055 15.553575,21.0363055 15.3583128,20.8410434 L7.48285586,12.9655864 C7.16095195,12.6416393 7,12.3176921 7,11.993745 C7,11.6697979 7.16095195,11.3458507 7.48285586,11.0219036 L15.3583128,3.14644661 C15.553575,2.95118446 15.8701575,2.95118446 16.0654196,3.14644661 L16.7295574,3.81109873 C16.9247192,4.00626049 16.9248342,4.32264472 16.7298144,4.51794834 L9.26539568,11.993745 L16.7298144,19.4695417 C16.9248342,19.6648453 16.9247192,19.9812295 16.7295574,20.1763913 Z",
    fill: "inherit",
    id: "path-1-caret-left" + unique,
    transform: "translate(11.938002, 11.993745) scale(1, -1) rotate(-360.000000) translate(-11.938002, -11.993745) "
  }))));
};

CaretLeft.propTypes = propTypes;
var _default = CaretLeft;
exports["default"] = _default;